import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
  render() {
    return (
      <footer className="sitefooter">
        <div className="container">
          <div className="sitefooter__smallprint">
            <div className="wrapper">
              <div className="footer-navigation" style={{ marginTop: '1.5em' }}>
                <div className="footer-nav-col">
                  <ul>
                    <li>
                      <Link to="/documents">Policy Documents</Link>
                    </li>
                    <li>
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href={process.env.PUBLIC_URL + '/terms-of-business.pdf'}
                      >
                        Terms of Business
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-nav-col">
                  <ul>
                    <li>
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href={
                          process.env.REACT_APP_STAYSURE_URL + '/cookie-policy/'
                        }
                      >
                        Cookie Policy
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href={
                          process.env.PUBLIC_URL + '/terms-and-conditions.pdf'
                        }
                      >
                        Terms and Conditions
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-nav-col" style={{ marginRight: 0 }}>
                  <ul>
                    <li>
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href={process.env.PUBLIC_URL + '/privacy-policy.pdf'}
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href={
                          process.env.REACT_APP_STAYSURE_URL + '/complaints/'
                        }
                      >
                        Complaints
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer-social-media">
                <ul>
                  <li>
                    <a href="https://www.facebook.com/euLegendsTour/">
                      <i className="fab fa-facebook" /> Like us on Facebook
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/eulegendstour">
                      <i className="fab fa-twitter" /> Follow us on Twitter
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="legal-footer">
              <div className="wrapper">
                <p>
                  <small>
                    Staysure is a trading name of TICORP Limited. Staysure Golf
                    Insurance is arranged by TICORP Limited which is registered
                    in Gibraltar company number 111526. Registered ofﬁce: First
                    Floor, Grand Ocean Plaza, Ocean Village, Gibraltar. TICORP
                    Limited is licensed and regulated by the Gibraltar Financial
                    Services Commission number FSC1238B and trades into the UK
                    on a freedom of services basis, FCA FRN 663617.
                    <br />
                    Staysure Golf Insurance is administered by Howserv Limited
                    which is registered in England and Wales number 03882026.
                    Registered office: Britannia House, 3-5 Rushmills business
                    park, Bedford Road, Northampton, NN4 7YB. Howserv Limited is
                    authorised and regulated by the Financial Conduct Authority
                    FRN 599282.
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
